import type { AccountingGroupDto, AccountingOperationDto } from '@shared/api/contracts';

export interface FlatAccountingOperation extends AccountingOperationDto {
  isFirstInGroup: boolean;
}

export const flattenAccountingGroups = (
  operations: AccountingGroupDto[] | null | undefined
): FlatAccountingOperation[] => {
  if (!operations || !Array.isArray(operations)) {
    return [];
  }

  const result: FlatAccountingOperation[] = [];

  operations.forEach((group) => {
    if (Array.isArray(group)) {
      group.forEach((item, index) => {
        result.push({
          ...item,
          isFirstInGroup: index === 0,
        });
      });
      return;
    }

    result.push({
      ...group,
      isFirstInGroup: true,
    });
  });

  return result;
};
